import TextInput from '@/common/components/base/input/textInput/TextInput';
import { PERSIAN_LATTER_RULE } from '@/common/components/base/input/textInput/textInput.rules';
import { requiredText } from '@/common/utils/rules/publicRules';

const InitialLegalOwnerForm = () => {
  return (
    <>
      <TextInput
        rules={{ required: requiredText, ...PERSIAN_LATTER_RULE }}
        name="personal_information.name"
        label="نام"
      />
      <TextInput
        rules={{ required: requiredText }}
        name="personal_information.registration_number"
        label="شماره ثبت"
      />
      <TextInput
        name="personal_information.economic_code"
        label="کد اقتصادی"
        rules={{ required: requiredText }}
      />
      <TextInput
        name="personal_information.national_id"
        label="شناسه ملی"
        rules={{ required: requiredText }}
      />
    </>
  );
};
export default InitialLegalOwnerForm;
